import { concantQuery } from '@/utils/concatQuery'
import EventEmitter from '@/utils/EventEmitter'
import api from './api'

export const ManagersManagerEventEmitter = new EventEmitter()

const wsEvents = {
  USER_MANAGER_DELETE_USER: 'USER_MANAGER_DELETE_USER',
  USER_MANAGER_UPDATE_USER: 'USER_MANAGER_UPDATE_USER',
  USER_MANAGER_ADD_USER: 'USER_MANAGER_ADD_USER',
}

/**
 * Listen websocket event
 * Example: wsListeners[wsEvents.SOME_EVENT](callback)
*/
const wsListeners = (() => {
  const listeners = Object.keys(wsEvents)
    .reduce((acc, eventName) => {
      acc[eventName] = (fn) => ManagersManagerEventEmitter.on(eventName, fn)
      return acc
    }, {})

  return listeners
})()

const wrapAction = (action) => {
  if (!wsActions.socket) {
    ManagersManagerEventEmitter.on('connect', action)
  } else {
    action()
  }
}

const wsActions = {
  socket: null,
  ACTION_JOIN_TO_USER_MANAGER: () => {
    wrapAction(() => wsActions.socket.emit('ACTION_JOIN_TO_USER_MANAGER'))
  },
  ACTION_DELETE_USER: (...args) => {
    wrapAction(() => wsActions.socket.emit('ACTION_DELETE_USER', ...args))
  }
}

/**
 *
 * @param {Socket} socket
 */
function bindWsEvents (socket) {
  Object.keys(wsEvents).forEach(eventName => {
    socket.on(eventName, (args) => ManagersManagerEventEmitter.emit(eventName, args))
  })

  wsActions.socket = socket
}

/**
 * Get managers.
 * @param {*} param0
 * @returns
*/
const loadManagers = ({ take, skip, search }) => {
  const query = concantQuery({ take, skip, search })
  return api.get(`/statistical/managers${query}`)
}

/**
 * Get manager's history.
 * @param {*} param0
 * @returns
*/
const loadHistory = ({ take, skip, search }) => {
  const query = concantQuery({ take, skip, search })
  return api.get(`/statistical/history${query}`)
}

/**
 * Change user password.
 * @param {string} password    - Current user password.
 * @param {string} newPassword - New user password.
 * @returns {Promise}
 */
 async function changePassword({ newPassword, password }) {
  return await api.post('/user/change-password', { newPassword, password })
}


export {
  loadManagers,
  loadHistory,
  changePassword,
  bindWsEvents,
  wsEvents,
  wsListeners,
  wsActions
}
